const { connect } = require('react-redux');
const { context } = require('app-context');
const { push: Push } = require('connected-react-router');

const MyGroupsPage = require('../components/MyGroupsPage');

const { ALL_GROUPS_SORT_TYPE } = require('utils/constants');

const selectors = context.selectors.all;
const actions = context.actions;

const updateSortPreference = (sortType) => {

    return function (dispatch) {

        return dispatch(actions.profileManagement.updateUserPreferences({
            sortGroupsBy: sortType
        }))
            .catch((error) => {

                console.error('Failed to update sort preference:', error);
            });
    };
};

module.exports = connect(
    (state) => ({
        rolePermissions: selectors.getCurrentUserRolePermissions(state),
        role: selectors.getCurrentUserRole(state),
        twilioChannelsLoading: selectors.getTwilioChannelsLoading(state),
        allGroupsSortType: selectors.getSortGroupsByPreference(state),
        setAllGroupSortType: ALL_GROUPS_SORT_TYPE.BY_NAME
    }),
    {
        onRequestRemoveClass: actions.classes.leave,
        setAllGroupSortType: actions.classes.setAllGroupSortType,
        updateSortPreference,
        push: Push
    }
)(MyGroupsPage);
